import { Paragraph } from '@econsult/econsult-ui/dist/components/shared/typography';
import { UnableToManageStateSvg } from 'assets';
import { FlexColumnDiv } from 'components/Div/styles';
import styled from 'styled-components';
import theme from 'styles/theme';

export const DeniedActionContainer = styled(FlexColumnDiv)`
  align-items: center;
  justify-content: flex-start;
  padding-top: 152px;
  height: 100%;
  width: 100%;
  text-align: center;
  color: ${theme.colorPrimaryPrimary100};
`;

export const DeniedText = styled(Paragraph).attrs({ typography: 'ParagraphSmallRegular' })``;

export const UnableToManageStateImage = styled(UnableToManageStateSvg)``;
